








import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import TabBase, { TabOption } from '@/components/atoms/TabBase.vue'
import AccordionBase from '@/components/atoms/AccordionBase.vue'
import StudentHistoryContent, { History } from '@/components/organisms/v3/StudentHistoryContent.vue'

export type GradeHistories = {
  gradeName: string
  gradeCode: string
  histories: History[]
  date?: string
  count?: number
}

@Component({
  components: {
    TabBase,
    AccordionBase,
    StudentHistoryContent,
  },
})
export default class AccordionStudentHistory extends Vue {
  @Prop()
  gradeHistories!: GradeHistories[]

  @Prop({ default: false })
  isTeacher?: boolean

  @Prop()
  gradeCode?: string

  @Prop({ default: '' })
  selectedSubject?: string

  @Watch('gradeHistories')
  onGradeHistoriesChange() {
    this.activeTabId = this.defaultActiveTabId
  }

  private get tabs(): TabOption[] {
    return this.gradeHistories.map((data, index) => {
      return { id: index + 1, name: data.gradeName }
    })
  }

  private activeTabId = this.defaultActiveTabId

  // propで渡されたgradeCodeのタブを初期表示する、ない場合は最初のタブを表示する
  private get defaultActiveTabId(): number {
    if (!this.gradeCode) return 1
    const gradeIndex = this.gradeHistories.findIndex((data) => {
      return data.gradeCode === this.gradeCode
    })
    return gradeIndex !== -1 ? gradeIndex + 1 : 1
  }

  get tabIndex() {
    const tabId = this.activeTabId
    return this.tabs.findIndex((el) => el.id === tabId)
  }
}
